import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MysteryCard } from "@/components/MysteryCard";

export function ContinueExploring({ id }) {
  const [list, setList] = useState([]);
  useEffect(() => { api.get(`/dossiers/${id}/suggestions`).then((r) => setList(r.data)).catch(() => setList([])); }, [id]);
  return (
    <section id="continua" data-testid="continue-exploring" className="scroll-mt-6 space-y-5 border-t border-[var(--luma-line)] pt-10">
      <div className="flex items-end justify-between gap-4">
        <h2 className="text-2xl font-extrabold sm:text-[32px]">Continua a esplorare</h2>
        <Link to="/misteri" data-testid="see-all-mysteries-link" className="flex min-h-[44px] shrink-0 items-center text-sm font-bold text-[var(--luma-action)] hover:underline">Tutti i misteri →</Link>
      </div>
      {list.length > 0 && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {list.map((x) => <MysteryCard key={x.id} d={x} voted={x.gia_votato} testid={`suggestion-card-${x.id}`} />)}
        </div>
      )}
    </section>
  );
}
